export const TAB_STATES = {
  CLIENT: 'CLIENT',
  LEDGER: 'LEDGER',
  ACCOUNT: 'ACCOUNT',
};

export const SEARCH_META_KEYS = {
  clientId: {
    display: 'Client ID',
    placeholder: 'Search by Client ID'
  },
  accountId: {
    display: 'Account ID',
    placeholder: 'Search by Account ID'
  },
  ledgerId: {
    display: 'Ledger ID',
    placeholder: 'Search by Ledger ID'
  },
};

export const SETTLEMENT_SERVICE_DASHBOARD_STRINGS = {
  HEADING: 'Settlement Service Dashboard',
  STRING_CONSTANTS: {
    [TAB_STATES.CLIENT] : {
      HEADING: 'Client Settlements',
      INPUT_MODAL_TITLE: 'Add A New Client Settlement',
      VIEW_CLIENT_DETAILS: 'View Client Details',
      UPDATE_CLIENT_DETAILS: 'Update Client Details',
      GET_CLIENT_DETAILS: 'Get Client Details',
      CLIENT_ID: 'Client ID',
      CLIENT_NAME: 'Client Name',
      CLIENT_EMAIL: 'Client Email',
      CLIENT_PHONE: 'Client Phone',
      CLIENT_STATUS: 'Client Status',
      CREATED_DATE: 'Created Date',
      LAST_UPDATED: 'Last Updated',
      SEARCH_CLIENT: 'Search Client',
      NO_CLIENTS_FOUND: 'No Clients Found!',
      ADD_NEW_CLIENT: 'Add New Client',
      EDIT_CLIENT: 'Edit Client',
      DELETE_CLIENT: 'Delete Client'
    },
    [TAB_STATES.LEDGER] : {
      HEADING: 'Ledger Settlements',
      INPUT_MODAL_TITLE: 'Add A New Ledger Settlement',
      ACCESS_LEDGER: 'Access Ledger',
      STATEMENT_INFORMATION: 'Statement Information',
      LEDGER_ID: 'Ledger ID',
      LEDGER_NAME: 'Ledger Name',
      LEDGER_TYPE: 'Ledger Type',
      BALANCE: 'Balance',
      CURRENCY: 'Currency',
      LAST_TRANSACTION: 'Last Transaction',
      TRANSACTION_COUNT: 'Transaction Count',
      SEARCH_LEDGER: 'Search Ledger',
      NO_LEDGERS_FOUND: 'No Ledgers Found!',
      VIEW_STATEMENT: 'View Statement',
      DOWNLOAD_STATEMENT: 'Download Statement',
      FILTER_BY_DATE: 'Filter by Date',
      FILTER_BY_TYPE: 'Filter by Type',
      ADD_NEW_LEDGER: 'Add New Ledger',
    },
    [TAB_STATES.ACCOUNT] : {
      HEADING: 'Account Settlements',
      INPUT_MODAL_TITLE: 'Add A New Account Settlement',
      CREATE_NEW_ACCOUNT: 'Create New Account',
      UPDATE_CLIENT: 'Update Client',
      GET_ALL_CLIENTS: 'Get All Clients',
      FETCH_CLIENT_DETAILS: 'Fetch Client Details',
      ACCOUNT_ID: 'Account ID',
      ACCOUNT_NAME: 'Account Name',
      ACCOUNT_TYPE: 'Account Type',
      ACCOUNT_STATUS: 'Account Status',
      ACCOUNT_BALANCE: 'Account Balance',
      ACCOUNT_CURRENCY: 'Account Currency',
      CREATED_DATE: 'Created Date',
      LAST_ACTIVITY: 'Last Activity',
      SEARCH_ACCOUNT: 'Search Account',
      NO_ACCOUNTS_FOUND: 'No Accounts Found!',
      ADD_ACCOUNT: 'Add Account',
      EDIT_ACCOUNT: 'Edit Account',
      DELETE_ACCOUNT: 'Delete Account',
      ACCOUNT_OPERATIONS: 'Account Operations',
      ADD_NEW_ACCOUNT: 'Add New Account'
    }
  }
};

export const SSD_LEDGERS_DEFAULT_FILTERS = {
  tenant: [],
};